import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../constants/queryKeys';
import { getStoredSignupGoal } from '../../constants/signupGoals';
import ApiService from '../../services/api';
import { API_CACHE_TTL } from '../../services/apiRequestCache';

export function useCarbonSavingsQuery(enabled = true) {
  return useQuery({
    queryKey: queryKeys.carbon.savings('monthly'),
    queryFn: async () => {
      try {
        return await ApiService.getCarbonSavings({ period: 'monthly', includeTrends: false });
      } catch {
        return null;
      }
    },
    enabled,
    staleTime: 3 * 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useCarbonDashboardQuery(enabled = true) {
  return useQuery({
    queryKey: queryKeys.carbon.dashboard,
    queryFn: async () => {
      try {
        return await ApiService.getCarbonDashboard();
      } catch {
        return null;
      }
    },
    enabled,
    staleTime: API_CACHE_TTL.carbonDashboardMs,
    refetchOnWindowFocus: false,
  });
}

export function useFinanceOverviewQuery(enabled = true) {
  return useQuery({
    queryKey: queryKeys.finance.overview,
    queryFn: async () => {
      try {
        return await ApiService.getFinanceOverview();
      } catch {
        return null;
      }
    },
    enabled,
    staleTime: 3 * 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useMsmeAdvisoryQuery(enabled = true) {
  const signupGoal = getStoredSignupGoal() || 'baseline_footprint';
  const period = 'annual';

  return useQuery({
    queryKey: queryKeys.msme.advisory(signupGoal, period),
    queryFn: () =>
      ApiService.runMsmeAdvisory({
        signupGoal,
        period,
      }),
    enabled,
    staleTime: 10 * 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useReductionTargetQuery(enabled = true) {
  return useQuery({
    queryKey: queryKeys.msme.reductionTarget,
    queryFn: async () => {
      try {
        return await ApiService.getReductionTarget();
      } catch {
        return null;
      }
    },
    enabled,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}
